import Vue from 'vue';
import Vuex from 'vuex';
import SidebarStore from './modules/sidebar';
import AuthStore from './modules/auth';
import JobStore from './modules/job';
import ModalStore from './modules/modal';
import UserStore from './modules/user';
import DepartmentStore from './modules/department';
import CountryStore from './modules/country';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    sidebar: SidebarStore,
    auth: AuthStore,
    department: DepartmentStore,
    country: CountryStore,
    job: JobStore,
    modal: ModalStore,
    user: UserStore,
  },
});
